export default "__VITE_ASSET__DF60XIIT__"